import StatsCard from "components/Home/StatsCard";

interface IBusinessStats {
  businessStats: BusinessStatsType;
}
const BusinessStats: React.FC<IBusinessStats> = ({ businessStats }) => {
  const statsList = [
    {
      title: "Total amount customers spent at your business",
      amount: businessStats?.totalTransactionAmount,
      className: "bg-brightPurple border-brightPurple",
      color: "brightPurple",
    },
    {
      title: "Rewards your customers earned",
      amount: businessStats?.totalRewardsDistributed,
      className: "bg-brightPurple border-brightPurple",
      color: "brightPurple",
    },
    {
      title: "Rewards your customers redeemed",
      amount: businessStats?.totalRedeemAmount,
      className: "bg-brightPurple border-brightPurple",
      color: "brightPurple",
    },
  ];
  const highlightedText = "md:text-3xl text-2xl font-semibold";
  return (
    <>
      {/* For Desktop View */}
      <div className=" grid-cols-3 md:gap-10 gap-4 my-4 hidden md:grid">
        {statsList?.map((stat, index) => (
          <StatsCard
            prefix={stat?.title}
            color={stat?.color}
            value={`$${stat?.amount}`}
            className={stat?.className}
          />
        ))}
      </div>
      {/* For Mobile View */}
      <div className="flex flex-1 flex-col bg-brightPurple !border-opacity-50 p-4 rounded-lg justify-center items-center md:hidden">
        {statsList?.map((stat, index) => (
          <>
            <div className="flex flex-row md:w-4/5 gap-8 ">
              <div className=" text-navyBlue md:text-xl text-md  md:text-left  md:w-3/5">
                {stat?.title}
              </div>
              <div className={`${highlightedText} self-center`}>
                ${stat?.amount}
              </div>
            </div>
            {index + 1 < statsList?.length && (
              <div className="border border-black w-full my-4 border-opacity-5" />
            )}
          </>
        ))}
      </div>
    </>
  );
};

export default BusinessStats;
